import { useEffect } from 'react';
import api from '../../services/api';

const LandingPageMeta = () => {
    useEffect(() => {
        const updateMetaTags = async () => {
            try {
                const response = await api.get('/admin/settings/public');
                if (response.data.success) {
                    const data = response.data.data;
                    
                    // Update document title
                    if (data.site_title && data.site_branding) {
                        const title = `🌊 ${data.site_title} - ${data.site_branding}`;
                        document.title = title;
                        
                        // Update og:title
                        const ogTitleMeta = document.querySelector('meta[property="og:title"]');
                        if (ogTitleMeta) {
                            ogTitleMeta.setAttribute('content', title);
                        }
                        
                        // Update twitter:title
                        const twitterTitleMeta = document.querySelector('meta[name="twitter:title"]');
                        if (twitterTitleMeta) {
                            twitterTitleMeta.setAttribute('content', title);
                        }
                    }
                    
                    // Update descriptions
                    if (data.site_description) {
                        // Update meta description
                        const descMeta = document.querySelector('meta[name="description"]');
                        if (descMeta) {
                            descMeta.setAttribute('content', data.site_description);
                        }
                        
                        // Update og:description
                        const ogDescMeta = document.querySelector('meta[property="og:description"]');
                        if (ogDescMeta) {
                            ogDescMeta.setAttribute('content', data.site_description);
                        }
                        
                        // Update twitter:description
                        const twitterDescMeta = document.querySelector('meta[name="twitter:description"]');
                        if (twitterDescMeta) {
                            twitterDescMeta.setAttribute('content', data.site_description);
                        }
                    }
                    
                    // Update images
                    if (data.site_logo) {
                        // Update og:image
                        const ogImageMeta = document.querySelector('meta[property="og:image"]');
                        if (ogImageMeta) {
                            ogImageMeta.setAttribute('content', data.site_logo);
                        }
                        
                        // Update og:logo
                        const ogLogoMeta = document.querySelector('meta[property="og:logo"]');
                        if (ogLogoMeta) {
                            ogLogoMeta.setAttribute('content', data.site_logo);
                        }
                        
                        // Update twitter:image
                        const twitterImageMeta = document.querySelector('meta[name="twitter:image"]');
                        if (twitterImageMeta) {
                            twitterImageMeta.setAttribute('content', data.site_logo);
                        }
                    }
                    
                    // Update og:site_name
                    if (data.site_title) {
                        const ogSiteNameMeta = document.querySelector('meta[property="og:site_name"]');
                        if (ogSiteNameMeta) {
                            ogSiteNameMeta.setAttribute('content', data.site_title);
                        }
                    }
                    
                    // Update og:url with current page URL
                    const ogUrlMeta = document.querySelector('meta[property="og:url"]');
                    if (ogUrlMeta) {
                        ogUrlMeta.setAttribute('content', window.location.href);
                    }
                    
                    // Update og:type
                    const ogTypeMeta = document.querySelector('meta[property="og:type"]');
                    if (ogTypeMeta) {
                        ogTypeMeta.setAttribute('content', 'website');
                    }
                }
            } catch (error) {
                console.error('Failed to update landing page meta tags:', error);
            }
        };
        
        updateMetaTags();
    }, []);

    // Component returns null - no visual output
    return null;
};

export default LandingPageMeta;